import { render, staticRenderFns } from "./SupportExternalConversation.vue?vue&type=template&id=51e6cfa2&scoped=true&"
import script from "./SupportExternalConversation.vue?vue&type=script&lang=js&"
export * from "./SupportExternalConversation.vue?vue&type=script&lang=js&"
import style0 from "./SupportExternalConversation.vue?vue&type=style&index=0&id=51e6cfa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e6cfa2",
  null
  
)

export default component.exports